<template>
  <v-container fill-height wrap>
      <v-layout align-center justify-center :wrap="!$vuetify.breakpoint.mdAndUp">
        <v-flex xs12 sm10 md8 lg6>
          <v-card>
            <v-card-title>Contato</v-card-title>
            <v-card-text>
              <p><span class="font-weight-bold">Dra Esther de Alencar Araripe Falcão Feitosa</span></p>
              <p>Médica formada pela Universidade Federal do Ceará CRMCE 11753</p>
              <p>Residência de Radiologia e Diagnóstico por Imagem (RQE 7602) e Especialização em Neurorradiologia pelo Instituto de Radiologia (InRad) - FMUSP (RQE 9418).</p>
              <p>
                <span class="font-weight-bold">Lattes: </span>
                <a
                  href="http://lattes.cnpq.br/2568401596298179"
                >http://lattes.cnpq.br/2568401596298179</a>
              </p>
              <v-layout column wrap>
              <v-btn class="my-2" color="accent" @click="didTapEmail">
                <v-icon>email</v-icon>
                <span>neurorradiologiaintegrada@gmail.com</span>
              </v-btn>
              <v-btn class="my-2" color="accent" @click="didTapInstagram">
                <v-icon>mdi-instagram</v-icon>
                <span>@neurorradiologiaintegrada</span>
              </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    didTapEmail() {
      window.open('mailto:neurorradiologiaintegrada@gmail.com');
    },
    didTapInstagram() {
      window.open('https://www.instagram.com/neurorradiologiaintegrada/');
    },
    didTapLattes() {
      window.open('http://lattes.cnpq.br/2568401596298179');
    },
  },
};
</script>
